import React, { useState } from 'react'
import { Button, Grid } from '@mui/material'
import LogoImg from '../../assets/logo.png'
import Staff from '../../assets/staff.jpeg'
import { LeftColumn, RightColumn, useStyles } from './styles'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ggImage from '../../assets/google.png'
import { FiCopy } from 'react-icons/fi'

const Success = ({ open, img, data }) => {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    setCopied(true)
  }

  return open ? (
    <Grid container className={classes.slide}>
      <LeftColumn item xs={12} lg={5} xl={4}>
        <h1 className={classes.formTile}>Thank You</h1>
        <p className={classes.formSubtitle}>We appreciate your feedback!</p>
        <p>
          We strive to be a quality community partner and your feedback is
          greatly appreciated. Please click below to copy your testimonial and
          share on our Google page
        </p>
        <Grid container className={classes.share}>
          <Grid item xs={12}>
            <p>
              <b>
                <span>Step 1:</span>
              </b>
              Click to Copy
            </p>
          </Grid>
          <Grid item xs={12} md={4} lg={8}>
            <CopyToClipboard
              className={classes.btn}
              text={data.testimonial}
              onCopy={handleCopy}
            >
              <Button
                variant='contained'
                startIcon={<FiCopy />}
                color='thertiary'
              >
                <p>Copy</p>
              </Button>
            </CopyToClipboard>

            {copied ? <span style={{ color: 'red' }}>Copied.</span> : null}
          </Grid>
        </Grid>
        <Grid className={classes.google}>
          <Grid item xs={12}>
            <p>
              <b>
                <span className='p-strong'>Step 2: </span>
              </b>
              Click to Share
            </p>
          </Grid>
          <Grid item xs={12} md={4} lg={8}>
            <a
              href='https://www.google.com/search?q=seacrest+services&oq=seacrest+services&aqs=chrome.0.69i59j35i39j46i175i199i512j0i512j0i457i512j69i61l2j69i60.5776j0j4&sourceid=chrome&ie=UTF-8#lrd=0x88d9ae45d2f2ca63:0x5453ae6746c96a8f,3,,,'
              target='_blank'
              rel='noreferrer noopener'
            >
              <Button
                className={classes.btn}
                variant='contained'
                startIcon={
                  <img src={ggImage} alt='Google' width='21' height='auto' />
                }
                color='thertiary'
              >
                <p>Share to Google</p>
              </Button>
            </a>
          </Grid>
        </Grid>
      </LeftColumn>
      <RightColumn
        container
        item
        xs={12}
        lg={7}
        xl={8}
        imagebg={img}
        alignItems='center'
        justifyContent='center'
      >
        <Grid container item xs={12} justifyContent={'center'} spacing={2}>
          <Grid container item xs={11} justifyContent={'center'}>
            <img src={Staff} className={classes.staff} alt='staff' />
          </Grid>
          <Grid container item xs={12} justifyContent={'center'}>
            <img src={LogoImg} className={classes.logo} alt='logo' />
          </Grid>
          <p className={classes.thankText}>
            A huge thanks from the whole team!
          </p>
        </Grid>
      </RightColumn>
    </Grid>
  ) : null
}

export default Success
